import { defineSlotRecipe } from '@chakra-ui/react';

export const tooltipSlotRecipe = defineSlotRecipe({
  slots: ['content', 'arrowTip'],
  base: {
    content: {
      '--tooltip-bg': 'colors.surface',
      bg: 'surface',
      color: 'text',
      borderWidth: 'hairline',
      borderColor: 'border',
      borderRadius: 'md',
      px: '2.5',
      py: '1.5',
      fontSize: 'xs',
      boxShadow: '0 4px 16px rgba(0,0,0,0.5)',
    },
    arrowTip: {
      borderColor: 'border',
      bg: 'surface',
    },
  },
});
